import { CartPage, CheckoutPage, PasswordReset, ThankYouPage } from "@pages";
import { Loader } from "@temp/components";
import * as React from "react";
import { Route, Switch } from "react-router-dom";
import { accountPaths } from "../../userAccount/routes";
import * as paths from "./paths";
/* eslint-disable prettier/prettier */

var Account = React.lazy(function () {
  return import(
  /* webpackChunkName: "account" */
  "../../views/Account/Account");
});
var AccountConfirm = React.lazy(function () {
  return import(
  /* webpackChunkName: "account-confirm" */
  "../../views/Account/AccountConfirm");
});
var AllTypesPage = React.lazy(function () {
  return import(
  /* webpackChunkName: "all-types-page" */
  "../../views/AllTypes");
});
var ArchitectPage = React.lazy(function () {
  return import(
  /* webpackChunkName: "architect-page" */
  "../../views/Architect");
});
var CategoryPage = React.lazy(function () {
  return import(
  /* webpackChunkName: "category-page" */
  "../../views/Category");
});
var CategoryReviewsPage = React.lazy(function () {
  return import(
  /* webpackChunkName: "category-reviews-page" */
  "../../views/CategoryReviews");
});
var CheckoutLogin = React.lazy(function () {
  return import(
  /* webpackChunkName: "checkout-login" */
  "../../components/CheckoutLogin");
});
var CollectionPage = React.lazy(function () {
  return import(
  /* webpackChunkName: "collection-page" */
  "../../views/Collection");
});
var ContactsPage = React.lazy(function () {
  return import(
  /* webpackChunkName: "contacts-page" */
  "../../views/Contacts");
});
var HomePage = React.lazy(function () {
  return import(
  /* webpackChunkName: "home-page" */
  "../../views/Home");
});
var NotFound = React.lazy(function () {
  return import(
  /* webpackChunkName: "not-found" */
  "../../components/NotFound");
});
var OrderDetails = React.lazy(function () {
  return import(
  /* webpackChunkName: "order-details" */
  "../../userAccount/views/AccountOrderDetails");
});
var PrismicPage = React.lazy(function () {
  return import(
  /* webpackChunkName: "prismic-page" */
  "../../views/PrismicPage");
});
var ProductPage = React.lazy(function () {
  return import(
  /* webpackChunkName: "product-page" */
  "../../views/Product");
});
var ProjectPage = React.lazy(function () {
  return import(
  /* webpackChunkName: "project-page" */
  "../../views/Project");
});
var RealizationPage = React.lazy(function () {
  return import(
  /* webpackChunkName: "realization-page" */
  "../../views/Realization");
});
var ReviewsPage = React.lazy(function () {
  return import(
  /* webpackChunkName: "reviews-page" */
  "../../views/Reviews");
});
var SearchPage = React.lazy(function () {
  return import(
  /* webpackChunkName: "search-page" */
  "../../views/Search");
});
var UserAccount = React.lazy(function () {
  return import(
  /* webpackChunkName: "user-account" */
  "../../userAccount/routes");
});
var WishlistPage = React.lazy(function () {
  return import(
  /* webpackChunkName: "wishlist-page" */
  "../../views/Wishlist");
});
var BlogIndexPage = React.lazy(function () {
  return import(
  /* webpackChunkName: "blog-index-page" */
  "../../views/BlogIndexPage");
});
var BlogPage = React.lazy(function () {
  return import(
  /* webpackChunkName: "blog-index-page" */
  "../../views/BlogPage");
});
/* eslint-enable prettier/prettier */

export var Routes = function Routes() {
  return React.createElement(React.Suspense, {
    fallback: React.createElement(Loader, {
      full: true
    })
  }, React.createElement(Switch, null, React.createElement(Route, {
    exact: true,
    path: paths.baseUrl,
    component: HomePage
  }), React.createElement(Route, {
    path: paths.searchUrl,
    component: SearchPage
  }), React.createElement(Route, {
    path: paths.categoryUrl,
    component: CategoryPage
  }), React.createElement(Route, {
    path: paths.allTypesUrl,
    component: AllTypesPage
  }), React.createElement(Route, {
    path: paths.collectionUrl,
    component: CollectionPage
  }), React.createElement(Route, {
    path: paths.productUrl,
    component: ProductPage
  }), React.createElement(Route, {
    path: paths.cartUrl,
    component: CartPage
  }), React.createElement(Route, {
    path: paths.checkoutLoginUrl,
    component: CheckoutLogin
  }), React.createElement(Route, {
    path: accountPaths.baseUrl,
    component: UserAccount
  }), React.createElement(Route, {
    path: accountPaths.userOrderDetailsUrl,
    component: OrderDetails
  }), React.createElement(Route, {
    path: paths.guestOrderDetailsUrl,
    component: OrderDetails
  }), React.createElement(Route, {
    path: paths.accountUrl,
    component: Account
  }), React.createElement(Route, {
    path: paths.accountConfirmUrl,
    component: AccountConfirm
  }), React.createElement(Route, {
    path: paths.orderDetailsUrl,
    component: Account
  }), React.createElement(Route, {
    path: paths.addressBookUrl,
    component: Account
  }), React.createElement(Route, {
    path: paths.passwordResetUrl,
    component: PasswordReset
  }), React.createElement(Route, {
    path: paths.checkoutUrl,
    component: CheckoutPage
  }), React.createElement(Route, {
    path: paths.orderFinalizedUrl,
    component: ThankYouPage
  }), React.createElement(Route, {
    path: paths.wishlistUrl,
    component: WishlistPage
  }), React.createElement(Route, {
    path: paths.reviewsUrl,
    exact: true,
    component: ReviewsPage
  }), React.createElement(Route, {
    path: paths.categoryReviewsUrl,
    component: CategoryReviewsPage
  }), React.createElement(Route, {
    exact: true,
    path: paths.realizationUrl,
    component: RealizationPage
  }), React.createElement(Route, {
    path: paths.projectUrl,
    component: ProjectPage
  }), React.createElement(Route, {
    path: paths.architectUrl,
    component: ArchitectPage
  }), React.createElement(Route, {
    path: paths.contactsUrl,
    component: ContactsPage
  }), React.createElement(Route, {
    exact: true,
    path: paths.blogIndexUrl,
    component: BlogIndexPage
  }), React.createElement(Route, {
    exact: true,
    path: paths.blogPostUrl,
    component: BlogPage
  }), React.createElement(Route, {
    path: paths.prismicPage,
    component: PrismicPage
  }), React.createElement(Route, {
    component: NotFound
  })));
};
export default Routes;